import React from 'react';
import { IconProps } from '../types';

export const Bag: React.FC<IconProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" fill="white" />
    <path
      d="M16.6667 8H12.8485L10.6667 5L13.9394 4L16.6667 8ZM16.6667 8H20.4849L22.6667 5L19.3939 4L16.6667 8Z"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 10.6667H20"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8889 13.3333H13.4444L8.53181 22.6143C8.18257 23.2741 8 24.0093 8 24.7558C8 27.2839 10.0494 29.3333 12.5775 29.3333H20.7558C23.2839 29.3333 25.3333 27.2839 25.3333 24.7558C25.3333 24.0093 25.1508 23.2741 24.8015 22.6143L19.8889 13.3333Z"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
